import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@eluve/components';
import { useTranslation } from '@eluve/i18n';

export type DeleteTemplateAlertProps = {
  template: { id: string; name: string } | null;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void | Promise<void>;
  isDeleting: boolean;
};

export const DeleteTemplateAlert: React.FC<DeleteTemplateAlertProps> = ({
  template,
  onOpenChange,
  onConfirm,
  isDeleting,
}) => {
  const { t } = useTranslation();
  return (
    <AlertDialog open={Boolean(template)} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {t('appointmentTools.documents.deleteTemplateTitle')}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {t('appointmentTools.documents.deleteTemplateDescription', {
              name: template?.name ?? '',
            })}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{t('common.cancel')}</AlertDialogCancel>
          <AlertDialogAction
            variant="destructive"
            onClick={onConfirm}
            disabled={isDeleting}
          >
            {isDeleting
              ? t('appointmentTools.documents.deleting')
              : t('appointmentTools.documents.delete')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
